export enum UserConsentId {
  SERVICE_AGREEMENT = 'ServiceAgreement',
  PRIVACY_POLICY = 'PrivacyPolicy',
  FINANCIAL_SERVICE_GUIDE = 'PaidFinancialServiceGuide',
  PRODUCT_DISCLOSURE_STATEMENT = 'ProductDisclosureStatement',
  MARKET_DETERMINATION = 'MarketDetermination',
  TMD_SAVINGS_ACCOUNT = 'TmdSavingsAccount',
  USER_BACKGROUND_CHECK_AGREEMENT = 'UserBackgroundCheckAgreement',
}

export enum UserConsentType {
  PAID_SERVICE_AGREEMENT = 'PAID_SERVICE_AGREEMENT',
  PAID_PRIVACY_POLICY = 'PAID_PRIVACY_POLICY',
  PAID_BACKGROUND_CHECK = 'PAID_BACKGROUND_CHECK',
  PAID_FINANCIAL_SERVICE_GUIDE = 'PAID_FINANCIAL_SERVICE_GUIDE',
  PAID_PRODUCT_DISCLOSURE_STATEMENT = 'PAID_PRODUCT_DISCLOSURE_STATEMENT',
  PAID_MARKET_DETERMINATION = 'PAID_MARKET_DETERMINATION',
  PAID_TMD_SAVINGS_ACCOUNT = 'PAID_TMD_SAVINGS_ACCOUNT',
}
